import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=e8499714&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8499714')) {
      api.createRecord('e8499714', component.options)
    } else {
      api.reload('e8499714', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=e8499714&", function () {
      api.rerender('e8499714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2euXTcGnVa99s/JS/comp/ImgFallback2.vue"
export default component.exports